'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import { CTA } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import Cta from 'ContentComponents/cmv2/fields/Cta';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

export default class CtaContentOptions extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onFieldChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(SidebarInput, {
      onFieldChange: this.onFieldChange,
      value: field[DEFAULT],
      label: text(i18nKey(`defaultLabels.${CTA}`)),
      inputComponent: Cta,
      readOnly: readOnly
    });
  }

}
CtaContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};